<template>
  <div>
    <div class="tab" :class="['tab-'+tabIndex]">
      <ul>
        <li
          v-for="(item,index) in tab"
          :key="index"
          v-html="item.name"
          :class="{active:index===tabIndex}"
          @click="tabClick(item,index)"></li>
      </ul>
    </div>
    <div class="main-content">
      <div class="word-mark" v-show="tabIndex === 3">此页面世界地域主要指中英美日法德</div>
      <component :is="component"></component>
    </div>
  </div>
</template>

<script>
import ShenZhen from './ShenZhen'
import China from './China'
import World from './World'
import YGA from './YGA'
import {visitAdd} from '@/api'

export default {
  name: 'Home',
  data() {
    return {
      tab: [
        {name: '深圳市', component: 'ShenZhen'},
        {name: '粤港澳大湾区', component: 'YGA'},
        {name: '中国', component: 'China'},
        {name: '世界', component: 'World'}
      ],
      tabIndex: 0,
      component: ShenZhen
    }
  },
  components: {ShenZhen, China, World, YGA},
  created() {
    let params = {
      type: this.tabIndex + 1
    }
    this.visitAdd(params)
  },
  methods: {
    tabClick(item, index) {
      this.tabIndex = index
      this.component = item.component
      const params = {
        type: index+1
      }
      this.visitAdd(params)
    },
    visitAdd(params){
      visitAdd(params).then(res => {
        console.log(res)
      })
    }
  }
}
</script>
